import { actionTypes } from '../constants/actionTypes';
import api from '../services';

export const fetchCategoriesWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getTaxonomies(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_FAIL, payload};
    }
};

export const fetchOneTermWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getOneTerm(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false
            }));
        }).catch(error => {
            dispatch(failure({
                data: {},
                error: error.message,
                loading: false
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_ONE_TERM, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_ONE_TERM_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_ONE_TERM_FAIL, payload};
    }
};

export const fetchCategoriesStoreWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getTaxonomies(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_STORE, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_STORE_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_STORE_FAIL, payload};
    }
};

export const fetchCategoriesProductWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getTaxonomies(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false,
                total: response.total
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false,
                total: 0
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_PRODUCT, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_PRODUCT_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_CATEGORIES_PRODUCT_FAIL, payload};
    }
};


// WEBPACK FOOTER //
// ./src/actions/categories.tsx